fragment OrderItemPrintFragment on OrderItemPrint {

    order_item_id

    print_assignment_id
    print_cost_id
    print_handling_charge_id

    print_cost_code
    print_cost_key

    print_cost_color

    print_assignment_location

    print_handling_charge_code

    print_cost_price
    print_start_cost_price
    print_handling_charge_price

    discount
    total_print_cost
    total_print_handling_charge

    print_cost_type
    print_cost_info

    total_product_variation_quantity
    total_attachment_quantity
    total_imprint_quantity
    total_start_quantity
    total_handling_charge_quantity

    pcs_product_variation_cost
    total_product_variation_cost

    pcs_attachment_cost
    total_attachment_cost

    pcs_imprint_cost
    total_imprint_cost

    pcs_start_cost
    total_start_cost

    pcs_print_handling_charge
    total_print_handling_charge

    pcs_price
    total_price

    logo_filename_original
    logo_filename_filesystem

    logo_url
    logo_path

    notes

    created_at
    updated_at

}